'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const ViewsTrendChart = dynamic(() => import('./ViewsTrendChart'), { ssr: false });
const DmFunnelChart = dynamic(() => import('./DmFunnelChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-5 2xl:grid-cols-5 gap-6">
      <div className="xl:col-span-3">
        <ViewsTrendChart />
      </div>
      <div className="xl:col-span-2">
        <DmFunnelChart />
      </div>
    </div>
  );
}